import { configureStore } from "@reduxjs/toolkit";
import userReducer from "./userSlice";
import projectsReducer from "./projectsSlice";
import groupsReducer from "./groupsSlice";
import balanceScorecardReducer from "./balanceScorecardSlice";
import calculationSettingsReducer from "./calculationSettingsSlice";
import budgetSettingsReducer from "./budgetSettingsSlice";
import displayOptionsSettingsReducer from "./displayOptionsSettingsSlice";
import fieldsReducer from "./fieldsSlice";
import savedFiltersReducer from "./savedFiltersSlice";
import interviewsSettingsReducer from "./interviewsSettingsSlice";
import generalSettingsReducer from "./generalSettingsSlice";
import categoriesReducer from "./categoriesSlice";
import payfactorReducer from "./payfactorSlice";
import dataSettingImportReducer from "./dataSettingImportSlice";
import rolesReducer from "./rolesSlice";
import periodReducer from "./periodSlice";
import stateEmployeeReducer from "./stateEmployeeSlice";
import suggestedActionsReducer from "./suggestedActionsSlice";

import { createReduxEnhancer } from "@sentry/react";

const sentryReduxEnhancer = createReduxEnhancer({
  actionTransformer: action => {
    const transformedAction = {
      ...action,
      meta: {
        ...action.meta,
        arg: (action.meta?.arg ? '[REDACTED]' : undefined)
      },
      payload: (action.payload ? '[REDACTED]' : undefined)
    };

    return transformedAction;
  },
  stateTransformer: state => {
    // Transform the state to remove sensitive information
    const transformedState = {
      ...state,
      user: {
        ...state.user,
        name: (state.user.name ? '[REDACTED]' : ''),
        translation: null,
        error: (state.user.error ? '[REDACTED]' : null)
      },
      groups: {
        data: (state.groups.data ? '[REDACTED]' : null)
      },
      projects: {
        data: (state.groups.data ? '[REDACTED]' : null)
      },
      budgetSettings: {
        ...state.budgetSettings,
        budgets: (state.budgetSettings.budgets && state.budgetSettings.budgets.length > 0 ? '[REDACTED]' : []),
        error: (state.budgetSettings.error ? '[REDACTED]' : null)
      },
      balanceScorecard: {
        ...state.balanceScorecard,
        prefilledData: (state.balanceScorecard.prefilledData.data ? '[REDACTED]' : {}),
        error: (state.balanceScorecard.error ? '[REDACTED]' : null)
      }
    };

    return transformedState;
  }
});

export const makeStore = (preloadedState) => configureStore({
  preloadedState,
  reducer: {
    user: userReducer,
    projects: projectsReducer,
    groups: groupsReducer,
    balanceScorecard: balanceScorecardReducer,
    calculationSettings: calculationSettingsReducer,
    budgetSettings: budgetSettingsReducer,
    displayOptionsSettings: displayOptionsSettingsReducer,
    fields: fieldsReducer,
    savedFilters: savedFiltersReducer,
    interviewsSettings: interviewsSettingsReducer,
    generalSettings: generalSettingsReducer,
    categories: categoriesReducer,
    payfactors: payfactorReducer,
    dataSettingImport: dataSettingImportReducer,
    roles: rolesReducer,
    periods: periodReducer,
    stateEmployee: stateEmployeeReducer,
    suggestedActions: suggestedActionsReducer
  },
  enhancers: getDefaultEnhancers => {
    return getDefaultEnhancers().concat(sentryReduxEnhancer);
  },
});

export const store = makeStore();
